import React from 'react';
import { Popper, Popover, Heading } from '@zillow/constellation';
import { event } from '@zillow/universal-analytics';

function FieldTooltip(_ref) {
  var title = _ref.title,
    body = _ref.body,
    interactionEventCmsInfo = _ref.interactionEventCmsInfo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement(Popper, {
    triggered: /*#__PURE__*/React.createElement(Popover, {
      header: /*#__PURE__*/React.createElement(Heading, {
        level: 6
      }, title),
      body: body
    }),
    onOpen: function onOpen() {
      if (interactionEventCmsInfo) {
        event({
          envelope: {
            event_type_id: '5030',
            event_type_version_id: '1',
            event_template_id: '297',
            event_template_version_id: '1'
          },
          clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms_tooltip',
            trigger_object_nm: 'no_trigger_object'
          },
          semantic: {
            semantic_event_nm: 'cms_open'
          },
          cms_info: interactionEventCmsInfo
        });
      }
    },
    onClose: function onClose() {
      if (interactionEventCmsInfo) {
        event({
          envelope: {
            event_type_id: '2051',
            event_type_version_id: '1',
            event_template_id: '126',
            event_template_version_id: '1'
          },
          clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms_tooltip',
            trigger_object_nm: 'no_trigger_object'
          },
          semantic: {
            semantic_event_nm: 'cms_close'
          },
          cms_info: interactionEventCmsInfo
        });
      }
    }
  }));
}

export { FieldTooltip as default };
